import type { PlatformService } from "./base";
import type { SipAccount, SipExtSolanaProvider } from './types'
import { PlatformBaseService, PlatformId } from "./base";
import { bufferToHex, hexToBuffer, utf8ToHex } from "./utils";

function checkSipWalletExists() {
  if (typeof window === 'undefined' || !window.sip) {
    throw new Error('Sip Wallet not installed. Please install the wallet to use this feature.');
  }
}

export class BrowserWebService extends PlatformBaseService {
  override platformId = PlatformId.BrowserWeb;
  provider: SipExtSolanaProvider

  constructor(options: any) {
    super(options);
    this.provider = window.sip?.providers?.solana
  }

  override async heartbeat(count: number): ReturnType<PlatformService['heartbeat']> {
    return { count: count + 1 }
  }

  override async getAccount(): ReturnType<PlatformService["getAccount"]> {
    checkSipWalletExists();
    const account = await this.provider.connect();

    if (account?.length) {
      return account[0]
    }

    throw new Error('Account not found');
  }

  override async signMessage(message: string, account: SipAccount): ReturnType<PlatformService["signMessage"]> {
    let signature: string;
    const inputs = [{
      address: account.address,
      message: utf8ToHex(message),
      account
    }]
    const outputs = await this.provider.signMessage(...inputs);

    if (Array.isArray(outputs)) {
      signature = outputs[0]?.signature;
    } else {
      signature = outputs?.signature
    }

    if (!signature) {
      throw new Error("Signature is empty, please try again");
    }

    return signature;
  }

  override async getLocale(): ReturnType<PlatformService["getLocale"]> {
    const locale = localStorage.getItem('sip-locale') || 'en-US';
    return { locale }
  }

  override async getVersion(): ReturnType<PlatformService["getVersion"]> {
    const version = '0.0.0';
    return { version }
  }

  override async getFavoriteList(): ReturnType<PlatformService["getFavoriteList"]> {
    return []
  }

  override async getNetwork(): ReturnType<PlatformService["getNetwork"]> {
    if (this.options.isDev) {
      return {
        assets: [],
        basePath: "m/44'/501'",
        blockExplorerAddr: "https://solscan.io/account/[[address]]",
        blockExplorerTX: "https://solscan.io/tx/[[txHash]]",
        coingeckoID: "solana",
        coingeckoPlatform: "solana",
        currencyName: "SOL",
        currencyNameLong: "Solana",
        customTokens: false,
        decimals: 9,
        homePage: "https://solana.com/",
        icon: "/src/providers/solana/networks/icons/sol.png",
        isTestNetwork: false,
        name: "SOLANA",
        name_long: "Solana",
        node: "https://api.sip.trading/helius-api",
        provider: "solana",
        signer: ['ed25519-sol'],
      } as any
    }

    throw new Error("BrowserWebService.getNetwork is not implemented");
  }
}
